module.exports = __webpack_public_path__ + "static/media/telstraBlue.6d0701e4.svg";